export interface Credentials {
  email: string,
  scope: string,
  password: string,
}
